<div class="wrapper">
  <h1>{{ 'server-error.title' | transloco }}</h1>
</div>
